"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 * @since 1.3.0
 */
var core_1 = require("@angular/core");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var dynamic_communication_service_1 = require("../../../services/dynamic-communication.service");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var Observable_1 = require("rxjs/Observable");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var DynamicQuickFilterComponent = /** @class */ (function () {
    function DynamicQuickFilterComponent(kbService, classifierService, currentLanguageProvider, dynamicCommunicationService, stateService) {
        this.kbService = kbService;
        this.classifierService = classifierService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.dynamicCommunicationService = dynamicCommunicationService;
        this.stateService = stateService;
        /**
         * Event to listen to get created filter.
         * @type {EventEmitter<object>}
         * @default
         */
        this.getFilter = new core_1.EventEmitter();
        /**
         * Is used to init view after all needed info is loaded.
         * @type {boolean}
         * @private
         */
        this._isReady = false;
        this._ids = [];
    }
    Object.defineProperty(DynamicQuickFilterComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicQuickFilterComponent.prototype, "filterItems", {
        get: function () {
            return this._filterItems;
        },
        enumerable: true,
        configurable: true
    });
    DynamicQuickFilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.kbService.getMetaFields(this.categorySystemName).subscribe(function (metaFields) {
            var metaField = metaFields.find(function (field) {
                return field.getSystemName() === _this.filterSystemName;
            });
            if (metaField === undefined) {
                throw Error("Cannot find field with " + _this.filterSystemName + " systemName!");
            }
            if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER) {
                _this.classifierService
                    .loadClassifiersView(metaField.getCompoundCategorySystemName())
                    .subscribe(function (items) {
                    _this._filterItems = items;
                    _this.handleItems();
                    _this._isReady = true;
                }, function (err) { return console.error(err); });
            }
            else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE) {
                _this.kbService
                    .getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(_this.categorySystemName))
                    .mergeMap(function (metaCategory) {
                    return Observable_1.Observable.fromPromise(_this.stateService.getStates(metaCategory.getWFProcessId()));
                })
                    .subscribe(function (states) {
                    _this._filterItems = states;
                    _this.handleItems();
                    _this._isReady = true;
                }, function (err) { return console.error(err); });
            }
            else {
                throw Error(_this.filterSystemName + " systemName is not lookup field for " + _this.categorySystemName + " entity!");
            }
        }, function (err) { return console.error(err); });
    };
    DynamicQuickFilterComponent.prototype.onFilterChange = function (tabId) {
        var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
        if (tabId !== 0) {
            filterBuilder.is(this.filterSystemName, this._ids[+tabId]);
        }
        var filter = filterBuilder.build();
        this.getFilter.emit(filter.toJson());
        this.dynamicCommunicationService.applyQuickFilter(this.filterKey, filter);
    };
    DynamicQuickFilterComponent.prototype.getItemName = function (item) {
        if (item instanceof idm_workflow_service_client_js_1.StateDto) {
            return this.currentLanguageProvider
                .getCurrentLanguage()
                .map(function (language) {
                return item.getName().getValue(language.getId());
            });
        }
        else {
            return Observable_1.Observable.of(item.getName());
        }
    };
    DynamicQuickFilterComponent.prototype.trackByFunc = function (index, item) {
        if (item instanceof idm_classifier_service_client_js_1.ClassifierView) {
            return item.id;
        }
        return item.getId();
    };
    DynamicQuickFilterComponent.prototype.handleItems = function () {
        var _this = this;
        this._ids.push(-1);
        this._filterItems.forEach(function (item) { return _this._ids.push(item.getId()); });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicQuickFilterComponent.prototype, "categorySystemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicQuickFilterComponent.prototype, "filterSystemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DynamicQuickFilterComponent.prototype, "filterKey", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DynamicQuickFilterComponent.prototype, "getFilter", void 0);
    DynamicQuickFilterComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'dynamic-quick-filter',
            template: require('./quick-filter.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n                      <dynamic-quick-filter\n                        [categorySystemName]=\"'%{categorySystemName}'\"\n                        [filterSystemName]=\"'%{filterSystemName}'\"\n                        [filterKey]=\"'%{filterKey}'\">\n                      </dynamic-quick-filter>\n                   ",
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            dynamic_communication_service_1.DynamicCommunicationService,
            idm_workflow_service_client_js_1.StateService])
    ], DynamicQuickFilterComponent);
    return DynamicQuickFilterComponent;
}());
exports.DynamicQuickFilterComponent = DynamicQuickFilterComponent;
//# sourceMappingURL=quick-filter.component.js.map